import "./styles.scss";
import React, { useState, useEffect } from "react";
import { Spin, Table } from "antd";
import { IconButton, PrimaryButton } from "../custom_components/customButton";
import { MdAddCircle } from "react-icons/md";
import { FaTags } from "react-icons/fa";
import { RiDeleteBin2Fill, RiEdit2Fill } from "react-icons/ri";
import moment from "moment";
import { GoUnverified } from "react-icons/go";
import CustomDeleteModal from "../custom_components/customDeleteModal";
import { colorScheme } from "../contants/variables";
import { error, success } from "../contants/snackbars";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import AnnouncementForm from "../forms/announcement/announcementForm";
import {
  fetchAnnouncements,
  deleteAnnouncement,
} from "../stores/api_calls/announcements";

const ShortSticky = () => {
  const [showForm, setShowForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState({
    visible: false,
    data: {},
  });

  const columns = [
    {
      title: "Date Created",
      dataIndex: "date_created",
      key: "date_created",
      render: (text, record) => (
        <span>{moment(record.date_created).format("LL")}</span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text, record) => (
        <span>
          {record?.description?.blocks
            ?.map((article) => article.text)
            .join("")
            .slice(0, 200)}
        </span>
      ),
    },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: (text, record) => (
        <span>{record.is_active ? "Active" : "Inactive"}</span>
      ),
    },

    {
      title: "Action",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <div className="actions-icons-container">
          <IconButton
            className="icon-button edit"
            tootTipTitle="Edit"
            Icon={<RiEdit2Fill />}
            onClick={() =>
              setShowForm({ isEditing: true, visible: true, data: record })
            }
          />
          <IconButton
            className="icon-button delete"
            tootTipTitle="Delete"
            Icon={<RiDeleteBin2Fill />}
            onClick={() => onDelete(record.id)}
          />
        </div>
      ),
    },
  ];

  const onDelete = (id) => {
    const removeAnnouncement = deleteAnnouncement(id);
    removeAnnouncement
      .then((res) => {
        if (res.data.success) {
          success("Announcement deleted successfully");
          const pagination = {
            page: 1,
            limit: 10,
            category: "short-sticky-section"
          };
          fetchData(pagination);
        }
      })
      .catch((e) => {
        error(
          `Opps! ${e.response.data.server_response} . Fetched Failed. Please try again later`
        );
      });
  };

  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tablePagination, setTablePagination] = useState({
    current: 1,
    pageSize: 10,
    total: "",
    defaultPageSize: 10,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `Total ${total} items`,
    pageSizeOptions: ["10", "20", "30"],
  });

  useEffect(() => {
    fetchData({ page: 1, limit: 10, category: "short-sticky-section", });
  }, []);

  useEffect(() => {
    if (tablePagination.current || tablePagination.pageSize) {
      const pagination = {
        page: tablePagination.current,
        limit: tablePagination.pageSize,
        category: "short-sticky-section",
      };
  
      fetchData(pagination);
    }
  }, [tablePagination.current, tablePagination.pageSize]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTablePagination(pagination);
  };

  const fetchData = (data) => {
    setIsLoading(true);

    const announcements = fetchAnnouncements(data);
    announcements
      .then((res) => {
        if (res.data.success) {
          
          setTableData(res.data.data);
          setIsLoading(false);
          setTablePagination({
            ...tablePagination,
            total: res.data.meta.pagination.total,
          });
        }
      })
      .catch((e) => {
        setIsLoading(false);
        console.log(e);
      });
  };

  return (
    <div className="career-table-container">
      <div className="table-title-icon primary">
        <HiOutlineSpeakerphone />
      </div>
      <p className="table-title-text primary">Short Sticky Announcement</p>
      <div className="search-container">
        <div className="add-button-container">
          <PrimaryButton
            Icon={<MdAddCircle />}
            color={colorScheme.primary}
            label="Add New Announcement"
            onClick={() =>
              setShowForm({ isEditing: false, visible: true, data: null })
            }
          />
        </div>
      </div>

      <div className='scrollable-table-container'>
        <Table
          columns={columns}
          rowKey={(record) => record._id}
          dataSource={tableData}
          loading={{ indicator: <Spin size="large" />, spinning: isLoading }}
          pagination={tablePagination}
          onChange={handleTableChange}
          bordered
          sticky
        />
      </div>

      <AnnouncementForm
        visible={showForm.visible}
        onCancel={() => setShowForm({ ...showForm, visible: false })}
        addSuccess={(data) => {
          setTableData([...tableData, data]);
          setShowForm({ isEditing: false, visible: false, data: {} });
        }}
        isEditing={showForm.isEditing}
        data={showForm.data}
        refetchLists={() => fetchData({ page: 1, limit: 10, category: "short-sticky-section", })}
        announceType="shortsticky"
      />
    </div>
  );
};

export default ShortSticky;
